<template>
    <div class="playerControls">
        <div class="panelCol">
          <a href="#" @click.prevent="skip(-15)"><icon icon="backward"/></a>
        </div>
        <div class="panelCol">
            <play-btn :me="me" :post="post"/>
        </div>
        <div class="panelCol">
          <a href="#" @click.prevent="skip(15)"><icon icon="forward"/></a>
        </div>
        <div class="panelCol center">
            <progress-bar :me="me" :post="post"/>
        </div>
        <div v-if="!isMobile" class="panelCol">
            <volume-control :me="me" :isMobile="isMobile"/>
        </div>
        <div v-if="!isMobile" class="panelCol">
            <a href="#" @click.prevent="toggleFullScreen()"><icon icon="arrows-alt"/></a>
        </div>
        <div v-if="canAirplay" class="panelCol">
            <a href="#" @click.prevent="selectAirplayDevice()"><icon icon="tv"/></a>
        </div>

    </div>
</template>

<script>

    import PlayBtn from './PlayBtn.vue';
    import ProgressBar from './ProgressBar.vue';
    import VolumeControl from './VolumeControl.vue';
    import Icon from "../ui/Icon";

    export default {
        name: '',
        props: ['me', 'post', 'isMobile'],
        data() {
            return {
                canAirplay: false,
                videoTag: null
            }
        },
        mounted() {
            this.videoTag = document.getElementById('mainPlayer');
            this.$bus.$on('player.close', ()=>this.exitFullscreen());
            //this.determineAirplay()
        },
        methods: {
            toggleFullScreen(){
                let pl = document.getElementById('mainPlayer');
                if(!document.fullscreenElement && !document.mozFullScreenElement && !document.webkitFullscreenElement && !document.msFullscreenElement){
                    this.enterFullscreen(pl);
                } else {
                    this.exitFullscreen();
                }

            },
            enterFullscreen(element){
                if(element.requestFullscreen) {
                    element.requestFullscreen();
                } else if(element.mozRequestFullScreen) {
                    element.mozRequestFullScreen();
                } else if(element.msRequestFullscreen) {
                    element.msRequestFullscreen();
                } else if(element.webkitRequestFullscreen) {
                    element.webkitRequestFullscreen();
                }

            },
            exitFullscreen() {
                if(window.fullscreen && document.exitFullscreen) {
                    document.exitFullscreen();
                } else if(document.mozCancelFullScreen) {
                    document.mozCancelFullScreen();
                } else if(document.webkitExitFullscreen) {
                    document.webkitExitFullscreen();
                }
            },
            determineAirplay(){
                if (window.WebKitPlaybackTargetAvailabilityEvent) {
                    this.canAirplay = true;
                }
            },
            selectAirplayDevice(){
                const pl = document.getElementById('mainPlayer');
                if (!window.WebKitPlaybackTargetAvailabilityEvent) return;
                pl.webkitShowPlaybackTargetPicker();
            },
            skip(time) {
              let ms = this.me.currentTime;
              let newTime = ms + time;
              console.log(ms, newTime);
              if(newTime > 0 && newTime < this.me.duration) this.me.currentTime = newTime;
            }
        },
        components:{
            PlayBtn,
            ProgressBar,
            VolumeControl,
            Icon
        }
    }
</script>

<style lang="sass">

    @import '../../assets/sass/vars.scss';

    .playerControls
        display: table
        background-color: rgba(0,0,0,.5)

        a
            color: #FFF
            text-decoration: none
            &:hover
                opacity: .7

        .panelCol
            display: table-cell
            padding: 10px 20px

            @media screen and (max-width: $grid-sm)
                padding: 10px

        .center
            width: 100%

        .prog-bar
            padding: 6px 0

        .bar, .pointer
            height: 4px

        .bar-outer
            position: relative
            background-color: rgba(255,255,255, .3)

        .bar-inner
            background-color: rgba(255,255,255, 1)
            width: 50%

        .pointer
            top: 0
            width: 2px
            position: absolute
            display: none

        .prog-bar:hover .pointer
            display: block

            background-color: $colorPrimary


</style>



// WEBPACK FOOTER //
// src/components/player/ControlPanel.vue